var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRoom1 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.1211 2.90918C20.6566 2.90918 21.0908 3.34336 21.0908 3.87891V20.1211C21.0908 20.6566 20.6566 21.0908 20.1211 21.0908H3.87891C3.34336 21.0908 2.90918 20.6566 2.90918 20.1211V3.87891C2.90918 3.34336 3.34336 2.90918 3.87891 2.90918H20.1211ZM4.84863 19.1514H19.1514V4.84863H4.84863V19.1514Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRoom1);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/room_1.738dec29722a8bf3dc5d611e417ab615.svg";